import { replaceAllComplex, umcodeURL } from './mol_function';
import {
  SearchPagebrowserUrlToReactUrl,
  SearchPageReactUrlToApiUrl,
  SearchPageReactUrlToBrowserUrl,
} from './Page/components/pages/SearchPage/Route';

import { pushError } from './pushError';

function browserUrlToReactUrlIntern(pathname, search) {
  let result = '';
  if ((search == null || search == '') && pathname.indexOf('?') > 0) {
    let split = pathname.indexOf('?');
    search = pathname.substr(split);
    pathname = pathname.substr(0, split);
  }

  if (search != null && search.length > 1 && search[0] == '?')
    search = search.substr(1);

  if (pathname.startsWith('https://www.moluna.de')) {
    pathname = pathname.substr('https://www.moluna.de'.length);
  }

  if (pathname.length > 1 && pathname[0] == '/') pathname = pathname.substr(1);

  if (
    pathname == 'search_page/' ||
    pathname.endsWith('/s/') ||
    pathname.endsWith('/k/') ||
    (pathname == 'index.php' &&
      search.indexOf('main_page=advanced_search_result') != -1)
  ) {
    result = SearchPagebrowserUrlToReactUrl(pathname, search);
  } else if (pathname.startsWith('product_info/')) {
    if (search == '') result = '/' + pathname;
    else result = '/' + pathname + '?' + search;
  } else if (pathname == 'shopping_cart/') {
    result = '/shopping_cart/';
    if (search != null && search != '' && search != '?') {
      if (!search.startsWith('?')) result += '?';
      result += search;
    }
  } else if (pathname == 'check') {
    result = '/check';
  } else if (
    pathname.toLowerCase().startsWith('buch/') ||
    pathname.toLowerCase().startsWith('musik/') ||
    pathname.toLowerCase().startsWith('film/') ||
    pathname.toLowerCase().startsWith('spielware/') ||
    pathname.toLowerCase().startsWith('games/') ||
    pathname.toLowerCase().startsWith('game/') ||
    pathname.toLowerCase().startsWith('software/') ||
    pathname.toLowerCase().startsWith('kalender/') ||
    pathname.toLowerCase().startsWith('lifestyle/') ||
    pathname.toLowerCase().startsWith('schreibwaren/') ||
    pathname.toLowerCase().startsWith('noten/')
  ) {
    let indexKat = pathname.indexOf('/');
    let link1 = pathname.substr(indexKat + 1);
    let indexMinus = link1.indexOf('-');
    let productId = link1.substr(0, indexMinus);
    result = '/product_info/' + productId;
  } else if (pathname == '/') {
    result = '/';
  } else if (pathname == 'checkout_VR') {
    result = '/checkout_VR?' + search;
  } else if (pathname == 'checkout') {
    result = '/checkout?' + search;
  } else if (pathname == 'paymentResult') {
    result = '/paymentResult?' + search;
  } else if (pathname == 'login') {
    if (search != null && search.length > 0) {
      result = '/login?' + search;
    } else result = '/login';
  } else if (
    pathname == 'impressum' ||
    pathname == 'agb' ||
    pathname == 'datenschutz' ||
    pathname == 'widerrufsrecht' ||
    pathname == 'batterieentsorgung' ||
    pathname == 'kontakt' ||
    pathname == 'ueberuns' ||
    pathname == 'kundewerden' ||
    pathname == 'DerBUCHBUTLER' ||
    pathname == 'versandkosten' ||
    pathname == 'versandkosten_all' ||
    pathname == 'logistik' ||
    pathname == 'zahlung' ||
    pathname == 'partner' ||
    pathname == 'libripartner' ||
    pathname == 'faq' ||
    pathname == 'howToStart' ||
    pathname == 'best'
  ) {
    result = '/' + pathname;
  } else if (pathname.startsWith('konto')) {
    if (search != null && search.length > 0) {
      result = '/' + pathname + '?' + search;
    } else {
      result = '/' + pathname;
    }
  } else if (pathname.startsWith('versandkosten/')) {
    result = '/' + pathname;
  } else if (
    pathname == 'index.php' ||
    pathname == 'favicon.ico' ||
    pathname == '__webpack_hmr' ||
    pathname.endsWith('.hot-update.json')
  ) {
    result = '';
  } else {
    //debugger;
  }

  return result;
}

export function browserUrlToReactUrl(pathname, search) {
  let response = browserUrlToReactUrlIntern(pathname, search);
  return response;
}

export function reactUrlToApiUrl(pathname) {
  if (pathname.startsWith('/search_page/')) {
    return SearchPageReactUrlToApiUrl(pathname);
  } else if (pathname.startsWith('/product_info/')) {
    let productID = pathname.substring(14);
    return '/ProductInfo.php?products_id=' + productID;
  } else if (pathname.startsWith('/shopping_cart')) {
    return '/ShoppingCart.php';
  } else if (pathname == '/') {
    return '/StartPage.php';
  } else if (pathname.startsWith('/login')) {
    let parts = pathname.split('?');
    if (parts.length > 1) {
      let parts2 = parts[1].split('&');
      let resultItem: any = {};

      for (let i = 0; i < parts2.length; i++) {
        let kv = parts2[i].split('=');
        resultItem[kv[0]] = kv[1];
      }
      if (resultItem.token != undefined && resultItem.email) {
        let oneCommandItem = {
          command: 'emailActivate',
          commandParams: {
            token: resultItem.token,
            email: decodeURIComponent(resultItem.email),
          },
        };
        return (
          '/CreateUser.php?oneCommand=' +
          encodeURIComponent(JSON.stringify(oneCommandItem))
        );
      } else if (
        resultItem.reset != undefined &&
        resultItem.email != undefined &&
        resultItem.hash != undefined
      ) {
        let oneCommandItem = {
          command: 'lostPasswordCallback',
          commandParams: {
            reset: resultItem.reset,
            email: decodeURIComponent(resultItem.email),
            hash: decodeURIComponent(resultItem.hash),
          },
        };
        return (
          '/CreateUser.php?oneCommand=' +
          encodeURIComponent(JSON.stringify(oneCommandItem))
        );
      } else if (resultItem.action == 'lost') {
        return '/Standard.php';
      } else {
        debugger;
        throw new Error('Method path not implemented yet.');
      }
    } else return '/CreateUser.php';
  } else if (
    pathname == '/impressum' ||
    pathname == '/agb' ||
    pathname == '/datenschutz' ||
    pathname == '/widerrufsrecht' ||
    pathname == '/batterieentsorgung' ||
    pathname == '/kontakt' ||
    pathname == '/ueberuns' ||
    pathname == '/kundewerden' ||
    pathname == '/DerBUCHBUTLER' ||
    pathname == '/logistik' ||
    pathname == '/zahlung' ||
    pathname == '/partner' ||
    pathname == '/libripartner' ||
    pathname == '/faq' ||
    pathname == '/howToStart' ||
    pathname == '/best'
  ) {
    return '/Standard.php';
  } else if (pathname.startsWith('/checkout_VR')) {
    if (pathname.startsWith('/checkout_VR?action=callback&')) {
      return '/Checkout_VR.php?' + pathname.substring(29);
    } else return '/Checkout_VR.php';
  } else if (pathname.startsWith('/checkout')) {
    if (pathname.startsWith('/checkout?action=callback&')) {
      return '/Checkout.php?' + pathname.substring(29);
    } else return '/Checkout.php';
  } else if (pathname.startsWith('/konto')) {
    return '/Account.php';
  } else if (pathname.startsWith('/paymentResult')) {
    return '/Checkout.php?' + pathname.substring(15);
  } else if (pathname == '/check') {
    return '/index.php?frame=api&main_page=check';
  } else if (pathname == '/versandkosten') {
    return '/Standard.php?include=versandkosten_de';
  } else if (pathname.startsWith('/versandkosten/')) {
    return '/Standard.php?include=versand&land=' + pathname.substring(15);
  } else if (pathname == '/versandkosten_all') {
    return '/Standard.php?include=versandkosten_all';
  } else {
    debugger;
    throw new Error('Method path not implemented yet.');
  }
}

function reactUrlToBrowserUrlIntern(
  pathname: string,
  search: string,
  apidata: any,
) {
  if ((search == null || search == '') && pathname.indexOf('?') > 0) {
    search = pathname.substr(pathname.indexOf('?'));
    pathname = pathname.substr(0, pathname.indexOf('?'));
  }

  let result = '';

  if (pathname == '/search_page/') {
    result = SearchPageReactUrlToBrowserUrl(pathname, search);
  } else if (pathname.startsWith('/product_info/') && apidata != null) {
    result = apidata.body.linkShort;
  } else if (pathname.startsWith('/product_info/') && apidata == null) {
    result = '';
  } else if (pathname.startsWith('/shopping_cart')) {
    result = '/shopping_cart/';
    if (search != null && search != '' && search != '?') {
      result += search;
    }
  } else if (pathname == '/login' && search == '?action=lost') {
    result = pathname + search;
  } else if (
    pathname == '/impressum' ||
    pathname == '/agb' ||
    pathname == '/datenschutz' ||
    pathname == '/widerrufsrecht' ||
    pathname == '/batterieentsorgung' ||
    pathname == '/kontakt' ||
    pathname == '/ueberuns' ||
    pathname == '/kundewerden' ||
    pathname == '/login' ||
    pathname == '/werbungschnittstellen' ||
    pathname == '/DerBUCHBUTLER' ||
    pathname == '/logistik' ||
    pathname == '/checkout_VR' ||
    pathname == '/versandkosten' ||
    pathname == '/zahlung' ||
    pathname == '/partner' ||
    pathname == '/libripartner' ||
    pathname == '/faq' ||
    pathname == '/howToStart' ||
    pathname == '/best' ||
    pathname == '/onlyb2b' ||
    pathname == '/versandkosten_all' ||
    pathname == '/checkout'
  ) {
    result = pathname;
  } else if (pathname.startsWith('/konto')) {
    if (search == '' || search == null) {
      return pathname;
    } else {
      return pathname + search;
    }
  } else if (pathname == '/paymentResult') {
    let searchParams: any = parseSearch(search);
    if (
      searchParams.paymentType == 'BAG' ||
      searchParams.paymentType == 'BUCH_RECHNUNG' ||
      searchParams.paymentType == 'PAYPAL' ||
      searchParams.paymentType == 'TEST'
    ) {
      result = pathname + search;
    } else result = pathname;
  } else if (pathname.startsWith('/versandkosten/')) {
    result = pathname;
  } else if (pathname == '/') {
    result = '/';
  } else if (pathname == '') {
    result = '';
  } else {
    debugger;
  }

  return result;
}

export function parseSearch(search: string) {
  if (search.startsWith('?')) search = search.substring(1);
  let searchParams = search.split('&');
  let result = {};
  for (let i = 0; i < searchParams.length; i++) {
    let split = searchParams[i].split('=');
    result[split[0]] = split[1];
  }
  return result;
}

export function reactUrlToBrowserUrl(
  pathname: string,
  search: string,
  apidata: any,
) {
  let response = reactUrlToBrowserUrlIntern(pathname, search, apidata);
  return response;
}

export function reactUrlToTransactionName(reactUrl: string) {
  reactUrl = reactUrl.toLowerCase();

  if (reactUrl == '/') return '/';
  if (reactUrl.startsWith('/search_page/')) return '/search_page/';
  if (reactUrl.startsWith('/product_info/')) return '/product_info/';
  if (reactUrl.startsWith('/shopping_cart')) return '/shopping_cart';
  if (reactUrl.startsWith('/checkout_vr')) return '/checkout_VR';
  if (reactUrl.startsWith('/checkout')) return '/checkout';
  if (reactUrl.startsWith('/login')) return '/login';
  if (reactUrl.startsWith('/paymentresult')) return '/paymentResult';
  if (reactUrl == '/derbuchbutler') return '/DerBUCHBUTLER';
  if (reactUrl == '/kundewerden') return '/kundewerden';
  if (reactUrl == '/kontakt') return '/kontakt';
  if (reactUrl == '/versandkosten') return '/versandkosten';
  if (reactUrl == '/batterieentsorgung') return '/batterieentsorgung';
  if (reactUrl == '/zahlung') return '/zahlung';
  if (reactUrl == '/partner') return '/partner';
  if (reactUrl == '/datenschutz') return '/datenschutz';
  if (reactUrl == '/impressum') return '/impressum';
  if (reactUrl == '/agb') return '/agb';
  if (reactUrl.startsWith('/konto')) return '/konto';
  if (reactUrl == '/libripartner') return '/libripartner';
  if (reactUrl == '/logistik') return '/logistik';
  if (reactUrl == '/faq') return '/faq';
  if (reactUrl == '/howtostart') return '/howToStart';
  if (reactUrl == '/best') return '/best';
  if (reactUrl == '/best') return '/best';
  if (reactUrl.startsWith('/versandkosten')) return '/versandkosten_ausland';
  debugger;
  return '';
}
